enum InlineQuestionResponse {
    YES = 1,
    NO = 0,
    SKIP = -1,
}

export default InlineQuestionResponse;
